module.exports = __webpack_public_path__ + "img/37b8ee6ea033a7yy0c6b0918343b3a61.8bb26a85.png";